import { useEffect, useState } from "react";
import {
    Button, Box, CircularProgress, CssBaseline, Dialog, DialogContent, DialogTitle,
    Grid, IconButton, InputAdornment, TextField, Typography
} from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import { Redirect } from "react-router-dom";
import { getApiUrl } from "../../services/api_service";
import { Alert } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import NDReferralHeader from "../../components/shared/ndreferralheader";
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import VisibilityIcon from "@mui/icons-material/Visibility";
import PreviewRecordDialog from "../../components/shared/records/previewrecorddialog";

import Footer from "../../components/shared/footer";
import { bodyBg, buttonRed, darkcolor, dialogEditEvent, footerContainer, fullHeight, headerText, lightcolor, line, mainGrid, pcolor, pointer, rcolor, whitecolor } from "../../style2";
import BackToTop from "../../components/shared/scrollTop";
import ConfirmDialog from "../../components/shared/ConfirmDialog";
import { DownloadFormButton } from "../../components/shared/downloadformbutton";



export default function ReferralDetails() {
    const { orgCode, referralId } = useParams();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingDocs, setLoadingDocs] = useState(false);
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [forms, setForms] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [patient, setPatient] = useState(null);
    const [redirect, setRedirect] = useState('');
    const [allowSubmit, setAllowSubmit] = useState(null);
    const [allowUpload, setAllowUpload] = useState(null);
    const [showRefferalCompleteModal, setShowReferralCompleteModal] = useState(false);
    const [date, setDate] = useState('');
    const [docDate, setDocDate] = useState(Date.now());
    const [comingSoonDialogOpen, setComingSoonDialogOpen] = useState(false);
    const [previewRecord, setPreviewRecord] = useState(null);
    // State for custom confirmation dialog
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogCallback, setConfirmDialogCallback] = useState(null);
    const [confirmDialogDescription, setConfirmDialogDescription] = useState("");

    const [isLoggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setLoggedIn(true);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');
        //setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/PatientForm/getbyreferral/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForms(data.forms);
                        setPatient(data.referral)
                        setAllowSubmit(data.allowSubmit);
                        setAllowUpload(data.allowUpload);
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [referralId, date]);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');

        setLoadingDocs(true);
        fetch(`${getApiUrl()}/referraldocument/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setDocuments(data);
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to load documents.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoadingDocs(false);
            })
    }, [referralId, docDate]);

    const submitReferral = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setLoadingSubmit(true);
        fetch(`${getApiUrl()}/Patientreferral/setreferralcomplete/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setShowReferralCompleteModal(true);
                    setDate(Date.UTC());
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoadingSubmit(false);
            })
    }

    // Custom confirmation dialog logic
    const handleRemoveDocument = (documentId) => {
        setConfirmDialogDescription("Are you sure you want to remove this document? This action cannot be undone.");
        setConfirmDialogCallback(() => () => executeRemoveDocument(documentId));
        setConfirmDialogOpen(true);
    };

    const executeRemoveDocument = async (documentId) => {
        setConfirmDialogOpen(false);
        const authTokens = localStorage.getItem("authTokens");
        let token;
        if (authTokens) {
            try {
                const parsedAuthTokens = JSON.parse(authTokens);
                token = parsedAuthTokens?.accessToken;
            } catch (err) {
                setError("Invalid authentication tokens.");
                return;
            }
        }
        if (!token) {
            setError("No authentication token found.");
            return;
        }
        setLoadingDocs(true);
        setError("");
        try {
            const response = await fetch(`${getApiUrl()}/referraldocument/remove/${documentId}`, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                setDocDate(new Date());
            } else {
                const data = await response.json().catch(() => ({}));
                setError(data.error || "Unable to remove document.");
            }
        } catch (err) {
            setError("Unable to contact server.");
        } finally {
            setLoadingDocs(false);
        }
    };

    const endsWith = (source, target) => {
        return source.indexOf(target, source.length - target.length) !== -1;
    }

    const handleComingSoonDialogOpen = (r) => {
        setComingSoonDialogOpen(true);
        setPreviewRecord(r);
    };

    const handleComingSoonDialogClose = () => {
        setComingSoonDialogOpen(false);
        setPreviewRecord(null);
    };

    if (redirect !== "")
        return <Redirect to={redirect} />;

    return <Box sx={{ ...bodyBg, ...fullHeight }}>
        <CssBaseline />
        <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
        <NDReferralHeader date={Date.UTC()} orgCode={orgCode} isLoggedIn={isLoggedIn} logo="../../../Logo_Option_1.svg" />
        <Box pt={1} sx={{ ...bodyBg, marginTop: "5px" }} p={5}>
            {patient !== null ? <Grid container>
                <Grid xs={6} item>
                    <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "2rem" }}>{patient.firstName} {patient.surname}, {dayjs(patient.dob).format("DD/MM/YYYY")}</Typography>
                </Grid>
                <Grid xs={6} item>
                    <Box mb={1} mt={2} sx={{ textAlign: "right" }}>
                        {allowUpload ? <Button disabled={loadingDocs} onClick={() => { setOpenUploadDialog(true); }}
                            sx={{
                                border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.1rem",
                                height: "40px", borderRadius: "20px", paddingLeft: "15px", paddingRight: "15px"
                            }}> Upload</Button> : null}

                        <Button onClick={() => { submitReferral(); }}
                            title={allowSubmit === true ? "" : "Please complete and submit all questionnaires before submitting the referral."}
                            disabled={loading || loadingSubmit || allowSubmit !== true}
                            sx={{
                                marginLeft: "20px",
                                border: allowSubmit === true ? `1px solid ${rcolor}` : `1px solid ${whitecolor}`,
                                background: allowSubmit === true ? rcolor : whitecolor,
                                color: allowSubmit === true ? whitecolor : "grey", fontSize: "1.1rem",
                                paddingLeft: "15px", paddingRight: "15px",
                                height: "40px", borderRadius: "20px"
                            }}>{loadingSubmit ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Submit Referral</Button>
                    </Box>
                </Grid>
            </Grid> : null}
            {error !== "" ? <Box sx={{ padding: "10px 0px" }}><Alert severity="error">{error}</Alert></Box> : null}
            <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "1.5rem" }}>Forms</Typography>
            {loading ? <Box sx={{ padding: "10px 0px" }}><CircularProgress color="inherit" size="20px" marginRight={1} /> Loading Forms</Box> : null}
            {forms !== null && forms.map((form, index) => {
                return <Box mb={3} style={{ background: whitecolor }}
                    borderColor={form.status === 3 || form.status === 4 ? "#00BE62" : "rgb(241, 111, 111)"}
                    borderRadius={10} border={2} p={2} mt={2}>
                    <Box sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }}>
                        <Typography variant="h6" style={{ paddingRight: "20px", fontWeight: "bold" }}>
                            {form.title}
                        </Typography>
                        {form.status === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: "rgb(233, 30, 99)" }} /> : null}
                        {form.status === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                        {form.status === 3 || form.status === 4 ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }} mt={1} mb={1}>
                        {form.status === 1 ? <>
                            <Typography>Assigned: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>{dayjs(form.assignedAt).format("DD/MM/YYYY")}</Typography>
                            <Typography>Status: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>Assigned</Typography>
                        </> : null}
                        {form.status === 2 ? <>
                            <Typography>Assigned: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>{dayjs(form.assignedAt).format("DD/MM/YYYY")}</Typography>
                            <Typography>Status: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>In Progress</Typography>
                        </> : null}
                        {form.status === 3 ? <>
                            <Typography>Started: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>{dayjs(form.answerStartDate).format("DD/MM/YYYY")}</Typography>
                            <Typography>Status: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>Submitted ({dayjs(form.answerSubmitDate).format("DD/MM/YYYY")})</Typography>
                        </> : null}
                        {form.status === 4 ? <>
                            <Typography>Started: </Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>{dayjs(form.answerStartDate).format("DD/MM/YYYY")}</Typography>
                            <Typography>Status:</Typography>
                            <Typography style={{ marginLeft: "5px", marginRight: "20px", color: "#125D71" }}>Completed ({dayjs(form.answerCompleteDate).format("DD/MM/YYYY")})</Typography>
                        </> : null}

                    </Box>
                    <Box style={{ textAlign: "right" }}>
                        <DownloadFormButton color="error" form={form} />
                        <IconButton marginLeft={2} onClick={() => {
                            setRedirect(`/referral/processform/${orgCode}/${form.id}`);
                        }} ><PlayCircleOutlineIcon color="error" /></IconButton>
                    </Box>
                </Box>;
            })}
            {allowUpload ? <>
                <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "1.5rem" }}>Documents</Typography>
                {loadingDocs ? <Box sx={{ padding: "10px 0px" }}><CircularProgress color="inherit" size="20px" marginRight={1} /> Loading Documents</Box> : null}

                <Box sx={{ ...mainGrid, marginTop: "10px", padding: "20px" }}>
                    {(documents === null || documents.length === 0) && !loadingDocs ? <Box sx={{ padding: "10px 0px" }}><Alert severity="info">No documents uploaded.</Alert></Box> : null}
                    {documents !== null && documents.map((record, index) => {
                        return <Box sx={{ paddingX: 0 }}>
                            <Box>
                                <Grid container sm spacing={2} alignItems="center" style={{ minHeight: 80 }}>
                                    <Grid item xs={10} alignContent="center">
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {record.mime.indexOf("image/") > -1 ? <ImageIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("audio/") > -1 ? <AudioFileIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("video/") > -1 ?
                                                <OndemandVideoIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("application/") > -1 && (endsWith(record.displayName, ".pdf")) ?
                                                <PictureAsPdfIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : record.mime.indexOf("application/") > -1 ?
                                                    <ArticleIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            <Box>
                                                <Typography style={{
                                                    fontWeight: "normal",
                                                    fontSize: 16,
                                                    color: pcolor
                                                }}>
                                                    {record.displayName}
                                                </Typography>
                                                <Typography display="inline" style={{
                                                    fontWeight: "normal",
                                                    fontSize: 12,
                                                    color: darkcolor,
                                                }}> Date: {dayjs(record.createdAt).format("DD/MM/YY")} </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={1} justifyContent="flex-end" alignContent="center" textAlign="right">
                                        <IconButton disabled={loadingDocs} edge="end" aria-label="Download" onClick={() => handleComingSoonDialogOpen(record)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Grid><Grid item xs={1} justifyContent="flex-end" alignContent="flex-end" textAlign="right">
                                        <IconButton disabled={loadingDocs} style={{ marginLeft: "20px" }} edge="end" aria-label="Remove"
                                            onClick={() => handleRemoveDocument(record.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={line} />
                        </Box>
                    })}

                </Box>
            </> : null}
            <Dialog
                open={showRefferalCompleteModal}
                onClose={() => { setShowReferralCompleteModal(false); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    <Typography style={{ fontSize: "1.3rem", fontWeight: "bold" }}>Congratulations!</Typography>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>You have successfully
                        submitted the referral pack.</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                        If the referral is accepted, the child’s family
                        will be contacted with information about
                        waiting times and assessment appointment.</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                        In the meantime, if you have any questions,
                        contact the SPOA administrator</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>at email: <a href="mailto:dhcft.SPOA@nhs.net">dhcft.SPOA@nhs.net</a> or telephone: 0300 7900 264</Box>
                </DialogContent>
            </Dialog>

            {/* Custom confirmation dialog for document removal */}
            <ConfirmDialog
                open={confirmDialogOpen}
                title="Confirm Removal"
                description={confirmDialogDescription}
                confirmText="Remove"
                cancelText="Cancel"
                onConfirm={confirmDialogCallback}
                onCancel={() => setConfirmDialogOpen(false)}
            />
            <PreviewRecordDialog open={comingSoonDialogOpen} handleClose={handleComingSoonDialogClose} record={previewRecord} />
            {openUploadDialog ? <ReferralDocUpload uploadCount={documents === null ? 0 : documents.length} patientReferralId={referralId} onClose={() => {
                setOpenUploadDialog(false);
            }} onSaved={() => { setOpenUploadDialog(false); setDocDate(new Date()) }} /> : null}
        </Box>
        <BackToTop />
        <Box style={{ ...footerContainer, position: "static" }}>
            <Footer />
        </Box>
    </Box>;
}
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function ReferralDocUpload({ onClose, onSaved, patientReferralId, uploadCount }) {
    const maxFileUploadLimit = 4;
    const [attachments, setAttachments] = useState([]);
    const [date, setDate] = useState(Date.now());
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [maxFileUploadATime, setMaxFileUploadAtATime] = useState(maxFileUploadLimit);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (uploadCount < maxFileUploadLimit) {
            setMaxFileUploadAtATime(maxFileUploadLimit - uploadCount);
        } else {
            setMaxFileUploadAtATime(0);
        }
    }, [uploadCount]);

    const saveAttachments = () => {
        if (attachments === null || attachments.length === 0) {
            setError("Please upload some files.");
            return;
        }
        else {
            let validext = ".jpg,.jpeg,.png,.mp3,.mp4,.pdf,.doc,.docx";
            for (let k = 0; k < attachments.length; k++) {
                if (validext.indexOf(attachments[k].ext) === -1) {
                    setError("Invalid file format, please upload in jpg, jpeg, png, mp3, mp4, pdf, doc and docx formats.");
                    return;
                }
            }
        }
        const fd = new FormData();
        for (let k = 0; k < attachments.length; k++) {
            fd.append(`Files[${k}].File`, attachments[k].file);
            fd.append(`Files[${k}].Name`, `${encodeURIComponent(attachments[k].name)}.${attachments[k].ext}`);
            fd.append(`Files[${k}].DocumentType`, 3); // Assuming 3 is the type for referral documents
        }

        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError("");
        setSuccess("");
        let url = `${getApiUrl()}/ReferralDocument/upload/${patientReferralId}`;
        fetch(url,
            {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: fd
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAttachments([]);
                    setError("");
                    setSuccess("Documents uploaded successfully");
                    setTimeout(() => { onSaved(); }, 1500);

                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        setError(err.message || "An error occurred.");
                        console.log(err);
                    });
                }
            })
            .catch((err) => { setError(err.message || "An error occurred."); console.log(err); })
            .finally(() => { setLoading(false); });
    }

    return <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <Box sx={{ ...dialogEditEvent, backgroundColor: lightcolor, border: "1px solid #D9D9D9" }}>
            <Grid container xs={12} align="center" style={{ textAlign: "left" }}>
                <Grid item xs={11}>
                    <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
                        Document Upload
                    </Typography>
                </Grid>
                <Grid item xs={1} sx={{ ...pointer, color: rcolor, textAlign: "right" }}>
                    <CloseIcon onClick={() => {
                        if (!loading) {
                            onClose();
                        }
                    }} sx={{ width: "35px", height: "35px" }} />
                </Grid>
            </Grid>
            <DialogContent style={{ padding: "5px" }}>
                {maxFileUploadATime > 0 ? <Box style={{ backgroundColor: "#ffffff", padding: "8px 15px", marginBottom: "20px", borderRadius: "15px", marginTop: "10px", marginBottom: "10px" }}><Grid container xs={12}>
                    <Grid item xs={6}>
                        <Typography style={{ marginTop: "10px", color: pcolor }}>
                            Upload up to {maxFileUploadATime} documents, each no larger than 50 MB.
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "center" }}>
                        <Button disabled={loading} component="label" color="primary" size="large" style={{ backgroundColor: rcolor, color: whitecolor, borderRadius: "15px", marginTop: "10px" }} role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />}> Choose file(s)
                            <VisuallyHiddenInput multiple={true} type="file"
                                accept=".jpg, .png, .doc, .docx, .jpeg, .pdf, .mov, .mp3, .mp4" onChange={(e) => {
                                    setError("");
                                    let temp = attachments;
                                    for (let k = 0; k < e.target.files.length; k++) {
                                        if (e.target.files[k].size / (1024 * 1024) > 50) {
                                            setError("File size exceeds 50 MB limit.");
                                            return;
                                        }
                                        if (temp.length < maxFileUploadATime) {
                                            let n = e.target.files[k].name.split('.').shift();
                                            if (temp.filter(x => x.name === n).length > 0) {
                                                setError(`File with name "${n}" already exists. Please choose other file and try again.`);
                                                continue;
                                            }
                                            temp.push({
                                                file: e.target.files[k],
                                                name: e.target.files[k].name.split('.').shift(),
                                                ext: e.target.files[k].name.split('.').pop(),
                                                documentType: 1
                                            });
                                        } else {
                                            setError(`Only ${maxFileUploadATime} files accepted to upload.`);
                                            break;
                                        }
                                    }
                                    setAttachments(temp);
                                    setDate(new Date());

                                }} />
                        </Button>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 5, marginBottom: 5 }}>
                        {/* <LinearProgress variant="determinate" value={(attachments.length/maxFileUploadATime) * 100} /> */}
                        <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>Uploaded Documents: ({attachments.length}/{maxFileUploadATime})</Typography>
                    </Grid>
                </Grid>
                </Box> : null}
                <div>
                    {attachments.map((item, index) => {
                        return <Box style={{ padding: "8px", marginTop: "10px", backgroundColor: "#ffffff", paddingTop: '20px', borderRadius: "15px" }} data-date={date}>
                            <Grid container xs={12}>
                                <Grid item xs={6}>
                                    <TextField disabled={loading} error={item.name === ""} helperText={item.name === "" ? "Required" : ""} label="File Name" variant="outlined" fullWidth value={item.name} onChange={(e) => {
                                        attachments[index].name = e.target.value;
                                        setAttachments(attachments);
                                        setDate(new Date());
                                    }} InputProps={{
                                        endAdornment: <InputAdornment position="start">.{item.ext}</InputAdornment>,
                                        maxLength: 200
                                    }} />
                                </Grid>
                                <Grid item xs={1} style={{ textAlign: "right" }}>
                                    <IconButton disabled={loading} aria-label="delete" onClick={() => {
                                        let temp = attachments;
                                        temp.splice(index, 1);
                                        setAttachments(temp);
                                        setError("");
                                        setDate(new Date());
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>

                        </Box>
                    })}
                    {maxFileUploadATime === 0 ? <Typography style={{ textAlign: "center", color: "red", padding: "4px" }}>You have reached the maximum limit of {maxFileUploadLimit} documents.</Typography> : null}
                    {error !== "" ? <Box style={{ textAlign: "center", color: "red", padding: "4px" }}>{error}</Box> : null}
                    {success !== "" ? <Box style={{ textAlign: "center", color: "green", padding: "4px" }}>{success}</Box> : null}
                </div>
                {attachments.length > 0 ? <Box style={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
                    {loading ? <CircularProgress color="success" /> : <Button type="button" disabled={loading} sx={buttonRed} onClick={() => {
                        saveAttachments()
                    }}>Submit</Button>}
                </Box> : null}

            </DialogContent>
        </Box>
    </Dialog>;
}